const seo = {
  TITLE: "Saiph - Works",
  AUTHOR: "Saiph",
  DESCRIPTION: "Portfolio Website",
  TYPE: "WEBSITE",
  TWITTER_USERNAME: "@take_314",
  URL: "https://soundcloud.com/take_314",
  IMAGE_URL: "https://i1.sndcdn.com/avatars-000500514447-c75aqc-t500x500.jpg",
  DESCRIPTION: "Saiph - Works"
};

export default seo;



// WEBPACK FOOTER //
// ./src/data/seo.js